export default "__VITE_ASSET__C7_hDoB2__"